import { render, staticRenderFns } from "./HorzBarChart.vue?vue&type=template&id=3809cdbe&"
import script from "./HorzBarChart.vue?vue&type=script&lang=ts&"
export * from "./HorzBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports